import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import logo from './logo.svg';
import '../src/assests/brandvariables/Brandvariables.css';
import "./assests/css/fonts/fontStyles.css";
import './App.css';

/* ================= ADMIN ================= */
import AdminLogin from './screen/admin/AdminLogin/AdminLogin.js';
import AdminDashboard from './screen/admin/AdminDashboard/AdminDashboard';
import AdminAttendance from './screen/admin/AdminAttendance/AdminAttendance';
import AdminFeeManagement from './screen/admin/AdminFeeManagement/AdminFeeManagement';
import ExamManagement from './screen/admin/ExamManagement/ExamManagement';
import NotificationSystem from './screen/admin/NotificationSystem/NotificationSystem';
import CareerConsultation from './screen/admin/CareerConsultation/CareerConsultation';
import AdminReports from './screen/admin/AdminReports/AdminReports';
import AdminDisputesSupport from './screen/admin/AdminDisputesSupport/AdminDisputesSupport';
import AdminSetting from './screen/admin/AdminSetting/AdminSetting';
import CourseSemesterManagement from './screen/admin/CourseSemesterManagement/CourseSemesterManagement';
import AdminLogout from './screen/admin/Adminlogout/Adminlogout';
import AdminBlog from './screen/admin/AdminBlog/AdminBlog';
import SubAdminManagement from './screen/admin/SubAdminManagement/SubAdminManagement.js';
import DepartmentManagement from './screen/admin/DepartmentManagement/DepartmentManagement.js';
import AdmincmsManagement from './screen/admin/AdmincmsManagemet/AdmincmsManagement.js';
import AdminEventcms from './screen/admin/AdmincmsManagemet/AdminEventcms.js';
import Principalcms from './screen/admin/AdmincmsManagemet/Principalcms.js';
/* ================= TEACHER ================= */

import TeacherLogin from "./screen/teachers/auth/TeacherLogin";
import TeacherRegister from "./screen/teachers/auth/TeacherRegister.js";
import TeacherDashboard from "./screen/teachers/dashboard/TeacherDashboard";
import TeacherExam from "./screen/teachers/TeacherExam/TeacherExam";
import TeacherAttendance from "./screen/teachers/TeacherAttendance/TeacherAttendance.js";
import TeacherCourses from "./screen/teachers/TeacherCourses/TeacherCourses";
import TeacherGuessPaper from "./screen/teachers/TeacherGuessPaper/TeacherGuessPaper.js";
import TeacherNotifications from "./screen/teachers/TeacherNotification/TeacherNotification.js";
import TeacherResult from "./screen/teachers/TeacherResult/TeacherResult.js";
import TeacherHelpSupport from './screen/teachers/TeacherHelpSupport/TeacherHelpSupport.js';
import TeacherSetting from './screen/teachers/TeacherSetting/TeacherSetting.js';
import TeacherLogout from './screen/teachers/TeacherLogout/TeacherLogout.js';


/* ================= STUDENT ================= */

/* ================= UserSide ================= */
//import AppContext from './context/Appcontext';

import StudentMainLayout from "./layouts/StudentMainLayout";
import Home from "./screen/students/Home/Home";
import Courses from "./screen/students/Courses/Courses";
import CourseDetail from "./screen/students/CourseDetail/CourseDetail";
import About from "./screen/students/About/About";
import Contact from "./screen/students/Contact/Contact";
import Principal from "./screen/students/principal/Principal.js";
import Blogs from './screen/students/Blogs/Blogs.js';
import Eventpage from './screen/students/eventpage/EventPage.js';

import BlogsDetail from './screen/students/BlogsDetail/BlogsDetail.js';


/* ================= STUDENT Dashboard ================= */

import StudentLogin from "./screen/StudentDashboard/studentlogin/StudentLogin.js";
import StudentDashboard from "./screen/StudentDashboard/studentdashboardd/StudentDashboardd.js";
import FeeManagement from "./screen/StudentDashboard/FeeManagement/FeeManagement.js";
import StudentExam from "./screen/StudentDashboard/studentexam/StudentExam.js";
import StudentNotes from "./screen/StudentDashboard/stuentnotes/StudentNotes.js";
import HelpSupport from "./screen/StudentDashboard/helpandsupport/HelpSupport.js";
import StudentNotification from './screen/StudentDashboard/StudentNotification/StudentNotification.js';
import StudentSettings from './screen/StudentDashboard/StudentSettings/StudentSettings.js';
import LMSChatbot from './components/general/LMSChatbt/LMSChatbot.js';
import Testing from './screen/user/testing/Testing.js';
import TeacherManagement from './screen/admin/UserManagement/TeacherManagement.js';
import StudentLogout from './screen/StudentDashboard/studentlogout/StudentLogout.js';
// import Career from './screen/students/Career/Career.js';
import StudentCareer from './screen/StudentDashboard/StudentCareer/StudentCareer.js';


import StudentManagement from './screen/admin/UserManagement/StudentManagement.js';
import ProgramManagement from './screen/admin/Program/ProgramManagement.js';
import StudentRegister from './screen/StudentDashboard/StudentRegister/StudentRegister.js';
import TeacherStudentAttendance from './screen/teachers/TeacherStudentAttendance/TeacherStudentAttendance.js';
import StudentAttendance from './screen/StudentDashboard/StudentAttendance/StudentAttendance.js';
import FeeSubmission from './screen/StudentDashboard/FeeManagement/FeeSubmission.js';
import Admincmslayout from './layouts/Adminmasterlayout/Admincmslayout.js';
import AdmincmsHome from './screen/admin/AdmincmsManagemet/AdmincmsHome.js';
import ChatPage from './screen/general/Chatpage/Chatpage.js';
import MyRequests from './screen/StudentDashboard/MyRequest/MyRequest.js';
import AdminDisputeChat from './screen/admin/Admindispute/Admindispute.js';
import AdminDisputeDetail from './screen/admin/AdminDisputesSupport/AdminDisputeDetail.js';
import TeacherChats from './screen/teachers/teacherchats/teacherchats.js';
import TeacherMyRequests from './screen/teachers/Teacherrequest/Teacherrequest.js';
import PageNotFound from './screen/students/PageNotFound/PageNotFound.js';

const App = () => {
  const { pathname } = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Change to 'smooth' if you want smooth scrolling
    });
  }, [pathname]);

  // Check if current route is an admin, teacher, or student dashboard route
  const isAdminRoute = pathname.startsWith('/admin') ||
    pathname.startsWith('/teacher') ||
    pathname.startsWith('/student');

  return (
    <>

      <Routes>
        <Route path='/testing' element={<Testing />} />
        {/* ================= ADMIN ROUTES ================= */}

        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/sub/admin/management" element={<SubAdminManagement />} />
        <Route path="/admin/attendance" element={<AdminAttendance />} />
        <Route path="/admin/user/management" element={<StudentManagement />} />
        <Route path="/admin/teacher/management" element={<TeacherManagement />} />
        <Route path="/admin/fees" element={<AdminFeeManagement />} />
        <Route path="/admin/exam/management" element={<ExamManagement />} />
        <Route path="/admin/notifications" element={<NotificationSystem />} />
        <Route path="/admin/career/consultation" element={<CareerConsultation />} />
        <Route path="/admin/reports" element={<AdminReports />} />
        <Route path="/admin/departments" element={<DepartmentManagement />} />
        <Route path="/course/semester/management" element={<CourseSemesterManagement />} />
        <Route path="/admin/disputes/support" element={<AdminDisputesSupport />} />
        <Route path="/admin/dispute" element={<AdminDisputeChat />} />
        <Route path="/admin/disputes/detail" element={<AdminDisputeDetail />} />
        <Route path="/admin/setting" element={<AdminSetting />} />
        <Route path="/admin/logout" element={<AdminLogout />} />
        <Route path="/admin/blog" element={<AdminBlog />} />
        <Route path="/admin/program/management" element={<ProgramManagement />} />
        <Route path="/admin/cms/management" element={<AdmincmsManagement />} />
        <Route element={<Admincmslayout />}>
          <Route path="/Admin/Home/cms" element={<AdmincmsHome />} />
          <Route path="/Admin/Event/cms" element={<AdminEventcms />} />
          <Route path="/Admin/Principal/cms" element={<Principalcms />} />
        </Route>

        {/* Student Dashboard */}
        <Route path="/student-login" element={<StudentLogin />} />
        <Route path="/fee/management" element={<FeeManagement />} />
        <Route path="/fee/submission" element={<FeeSubmission />} />
        <Route path="/student-register" element={<StudentRegister />} />
        <Route path="/student/dashboard" element={<StudentDashboard />} />
        <Route path="/chat/:conversationId" element={<ChatPage />} />
        <Route path="/teacher-chat/:conversationId" element={<ChatPage />} />
        <Route path="/student/exam" element={<StudentExam />} />
        <Route path="/student/notes" element={<StudentNotes />} />
        <Route path="/student/myrequest" element={<MyRequests />} />
        <Route path="/help/support" element={<HelpSupport />} />
        <Route path="/student/notification" element={<StudentNotification />} />
        <Route path="/student/setting" element={<StudentSettings />} />
        <Route path="/student/attendance" element={<StudentAttendance />} />
        <Route path="/student/logout" element={<StudentLogout />} />
        <Route path="/student/career" element={<StudentCareer />} />


        {/* ================= FALLBACK ================= */}
        {/* <Route path="*" element={<Navigate to="/" />} /> */}
        {/* TEACHER SIDE ROUTES */}

        <Route path="/teacher/courses" element={<TeacherCourses />} />
        <Route path="/teacher-login" element={<TeacherLogin />} />
        <Route path="/teacher-register" element={<TeacherRegister />} />
        <Route path="/teacher/dashboard" element={<TeacherDashboard />} />
        <Route path="/teacher/exam" element={<TeacherExam />} />
        <Route path="/teacher/result" element={<TeacherResult />} />
        <Route path="/teacher/myrequest" element={<TeacherMyRequests />} />
        <Route path="/teacher/chats" element={<TeacherChats />} />
        <Route path="/teacher/attendance" element={<TeacherAttendance />} />
        <Route path="/teacher/guesspaper" element={<TeacherGuessPaper />} />
        <Route path="/teacher/notification" element={<TeacherNotifications />} />
        <Route path="/teacher/setting" element={<TeacherSetting />} />
        <Route path="/teacher/helpsupport" element={<TeacherHelpSupport />} />
        <Route path="/teacher/logout" element={<TeacherLogout />} />
        <Route path="/teacher/studentattendance" element={<TeacherStudentAttendance />} />

        {/* USER SIDE ROUTES */}

        <Route element={<StudentMainLayout />}>

          <Route path="/" element={<Home />} />
          <Route path="/aboutus" element={<About />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/courses/:id" element={<CourseDetail />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/eventpage" element={<Eventpage />} />
          {/* <Route path="/career" element={<Career />} /> */}
          <Route path='/principal' element={<Principal />} />
          <Route path='/blogs' element={<Blogs />} />
          <Route path='/blogsdetail' element={<BlogsDetail />} />
          <Route path="*" element={<PageNotFound />} />
        </Route>


      </Routes>
      {/* {!isAdminRoute && <LMSChatbot />} */}
    </>
  )
};

export default App;